import * as React from 'react';
import cn from 'classnames';
import ReactMarkdown = require('react-markdown');

const _styles = require('./SeoBlurb.scss');

export const SeoBlurb = (props: { data: string; expandText: string }) => {
    const { data, expandText } = props;
    const [collapsed, setCollapsed] = React.useState(true);

    return (
        <div className={_styles.blurb}>
            <div className={cn(_styles.textContainer, { [_styles.collapsed]: collapsed })}>
                <ReactMarkdown source={data} />
                {collapsed && <div className={_styles.fadeBox} />}
            </div>
            {collapsed && (
                <div onClick={() => setCollapsed(!collapsed)} className={_styles.expandContainer}>
                    {expandText}
                </div>
            )}
        </div>
    );
};
